import React from 'react';
import {Message, Icon} from 'epic-diesel-common';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    header: {
        display: 'flex',
        alignItems: 'center'
    },
    link: {
        color: 'white',
        lineHeight: 0
    },
    title: {
        marginRight: theme.spacing(9),
        marginLeft: theme.spacing(3),
        display: 'none',

        '& > span': {
            fontWeight: 400
        },

        [theme.breakpoints.up('lg')]: {
            display: 'inline-block'
        }
    }
}));

const Logo = () => {
    const styles = useStyles();
    return (
        <div className={styles.header}>
            <Link className={styles.link} href="https://www.epicgames.com">
                <Icon icon="EPIC" fontSize="large" titleAccess="Epic Logo" aria-label="Epic Logo" />
            </Link>

            <Typography classes={{root: styles.title}} variant="h4">
                <Message code="epic.affiliate.nav.title" />
            </Typography>
        </div>
    );
};

export default Logo;
